<template>
  <div class="page">
    <div v-if="getModuleConfig('external_member_customer_bind.binding_error.step_section.enable_step_section')" class="p-3">
      <SharedStep :steps="getModuleConfig('thanks_page.step_section.steps')" />
    </div>

    <div v-if="getModuleConfig('external_member_customer_bind.binding_error.form_title')" class="page__title">
      {{ getModuleConfig("external_member_customer_bind.binding_error.form_title") }}
    </div>

    <div class="page__desc" v-if="contentData" v-html="contentData"></div>

    <Toast v-if="shouldDisplayErrorMessage" variant="error" class="mb-3" style="max-width: none;">{{ errorMessage }}</Toast>

    <img
      v-for="image in contentImages"
      :src="image.image_url"
      :key="image.order"
      class="w-100"
    />

    <div class="page__button s-space-y-4">
      <MemberButton
        v-if="getModuleConfig('external_member_customer_bind.binding_error.button_text')"
        :button-text="getModuleConfig('external_member_customer_bind.binding_error.button_text')"
        :button-url="getModuleConfig('external_member_customer_bind.binding_error.button_url')"
        :type="getModuleConfig('external_member_customer_bind.binding_error.button_action')"
      ></MemberButton>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue"
import SharedStep from "@/components/Page/Liff/Shared/Steps"
import Toast from "@/components/Page/Liff/Shared/Toast";

export default {
  components: {
    SharedStep,
    MemberButton,
    Toast,
  },
  computed: {
    ...mapState("liffAuth", ["errorMessage"]),
    contentImages() {
      let contentImages = this.getModuleConfig("external_member_customer_bind.binding_error.content_images") || []
      contentImages.sort((a, b) => a.order - b.order)
      return contentImages
    },
    contentData() {
      return this.getModuleConfig("external_member_customer_bind.binding_error.content") ?? false
    },
    shouldDisplayErrorMessage() {
      return !!this.getModuleConfig("external_member_customer_bind.binding_error.show_error")
    },
  },
  methods: {
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]("member_register", key)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
